import { useTranslation } from 'react-i18next'
import { MainContentArea } from '@/components/layout/MainContentArea'
import { ContentNavigator } from '@/components/content/ContentNavigator'
import { useContentBundle } from '@/hooks/useContentBundle'
import { useAppStore } from '@/store/appStore'
import { trackPageView } from '@/services/appInsights'
import { AdditionalReadingCategory } from '@/types/api'

export function AppendicesPage() {
  const { t } = useTranslation()
  const { data: bundle, isLoading } = useContentBundle()
  const { isManualOffline, isTrulyOffline } = useAppStore()

  if (isLoading) {
    return (
      <MainContentArea>
        <div className="loading-state">{t('pages.loading')}</div>
      </MainContentArea>
    )
  }

  if (!bundle) {
    return (
      <MainContentArea>
        <div className="error-state">{t('content.unavailable')}</div>
      </MainContentArea>
    )
  }

  const appendixItems = bundle.additionalReading
    .filter((r) => r.category === AdditionalReadingCategory.Appendices)
    .sort((a, b) => a.sortOrder - b.sortOrder)

  const handleItemSelect = (item: { id: number; displayName: string }) => {
    const offlineMode = isManualOffline && isTrulyOffline ? 'both' : isManualOffline ? 'manual' : isTrulyOffline ? 'network' : 'none'
    trackPageView('Appendices', `/appendices/${item.id}`, {
      additionalReadingId: String(item.id),
      additionalReadingName: item.displayName,
      offlineMode,
    })
  }

  return (
    <MainContentArea>
      <ContentNavigator
        items={appendixItems}
        bundle={bundle}
        emptyMessage={t('pages.noAppendixContent')}
        navLabel={t('pages.appendixNav')}
        onItemSelect={handleItemSelect}
      />
    </MainContentArea>
  )
}
